import {
    GET_ALL_USERS_ADMIN,
    GET_USER_ADMIN,
    GET_BADGE,
    GET_BADGE2,
    GET_ROL,
    FE_LOADING,
    FE2_LOADING,
    ADD_USER_ADMIN
  } from "../actions/ExtracurricularCoursesAdminUserAction";
  
  
  const initialState = {
    userslist: [],
    user: [],
    UserBadge: [],
    UserBadge2: [],
    RolBadge: [],
    loading: false,
    loading2: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case FE_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }case FE2_LOADING: {
          return {
            ...state,
            loading2: true,
            add: false
          };
        }
        case GET_ALL_USERS_ADMIN: {
            return{
                ...state,
                userslist : [...action.data],
                user:[],
                loading: false,
                loading2: false,
                add : false,
            }
        }
        case GET_USER_ADMIN: {
          return{
              ...state,
              user : [...action.data],
              loading: false,
              loading2: false
          }
        }
        case GET_BADGE: {
          return{
              ...state,
              UserBadge : [...action.data],
              loading: false,
              loading2: false
          }
        }
        case GET_BADGE2: {
          return{
              ...state,
              UserBadge2 : [...action.data],
              loading: false,
              loading2: false
          }
        }
        case GET_ROL: {
          return{
              ...state,
              RolBadge : [...action.data],
              loading: false
          }
        }
        case ADD_USER_ADMIN: {
          return {
            ...state,
            user:[],
            UserBadge:[],
            add : true,
            loading: false , 
            loading2: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  